import { TimePeriod, eventType } from "../../../../API";

import { AutocompleteOptionType } from "../../../../common/models/autocomplete";
import Box from "@mui/material/Box";
import ChartTableContainer from "../system-health/components/ChartTableContainer";
import ConfirmedLeakDetectionsContainer from "./components/charts/ConfirmedLeakDetectionsContainer";
import FalsePositiveEventsContainer from "./components/charts/FalsePositiveEventsContainer";
import FeedbackDetailsContainer from "./components/charts/FeedbackDetailsContainer";
import Grid from "@mui/material/Grid";
import { ILeakLOCResponseModel } from "../system-performance/models/chart";
import { useCreateLeakLOCChart } from "./hooks/useCreateLeakLOCChart";

type FeedbackInsightsTabProps = {
  selectedLocation: AutocompleteOptionType[] | null;
  activeTimePeriod: TimePeriod;
};

const FeedbackInsightsTab: React.FC<FeedbackInsightsTabProps> = ({
  selectedLocation,
  activeTimePeriod,
}) => {
  const locationMapped = selectedLocation
    ? selectedLocation?.map(l => l?.value ?? "")
    : [];

  const getGasLeakLOCChart = useCreateLeakLOCChart<ILeakLOCResponseModel>(
    activeTimePeriod,
    locationMapped,
    eventType.locGasLeak
  );

  const getLiquidLeakLOCChart = useCreateLeakLOCChart<ILeakLOCResponseModel>(
    activeTimePeriod,
    locationMapped,
    eventType.locLiquidLeak
  );

  return (
    <Box
      sx={{
        gap: "1.5em 1.5em",
        display: "grid",
      }}
    >
      <Grid container alignItems="center" justifyContent="center" spacing={3}>
        <Grid item xs={12} md={12} lg={6}>
          <ChartTableContainer
            chartsData={getGasLeakLOCChart}
            title="Confirmed LOC Events (Gas)"
            tableItemName="Node"
            type="line"
            showChartOnly
          />
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <ChartTableContainer
            chartsData={getLiquidLeakLOCChart}
            title="Confirmed LOC Events (Liquid)"
            tableItemName="Liquid"
            type="line"
            showChartOnly
          />
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <ConfirmedLeakDetectionsContainer
            selectedLocations={locationMapped}
            activeTimePeriod={activeTimePeriod}
          />
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <FalsePositiveEventsContainer
            selectedLocations={locationMapped}
            activeTimePeriod={activeTimePeriod}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <FeedbackDetailsContainer
            activeTimePeriod={activeTimePeriod}
            selectedLocations={locationMapped}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeedbackInsightsTab;
